module.exports = __webpack_public_path__ + "static/media/CISA Logo Color PNG.e2e464af.png";